// extracted by mini-css-extract-plugin
module.exports = {"className":"ka-GE_className__e3C5p"};